import FormAccessory from "./Form/FormAccessory"

import api from '../../utils/api'

import { useState , useEffect} from 'react'

import { useParams } from 'react-router-dom'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

function EditAccessory({id , btCancelAction, handleOnSuccess}) {
    const [token] = useState(localStorage.getItem('token') || '')
    const {setFlashMessage} = useFlashMessage()
    

    
    const [accessory, setAccessory] = useState({})
    




    useEffect(() => {

        api.get(`/accessory/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
            
        }).then((response) => {
            
            setAccessory(response.data.accessory)
        })
    }, [token, id])





    async function updateAccessory(obj){
        
        let msgType = 'success'
        //check if accessory exists
       
        console.log("update")

            const formData = new FormData()
            await Object.keys(obj).forEach((key) => formData.append(key, obj[key]))


            const data = await api.patch(`/accessory/edit/${id}`, formData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token)}`,
                }
            }).then((response) => {
                return response.data
            })
                .catch((err) => {
                    msgType = 'error'
                    return err.response.data
                })

            setFlashMessage(data.message, msgType)

            if (msgType !== 'error') {
                handleOnSuccess()
                
            }
        

    }
    return (
        accessory.name && (
            <FormAccessory handleSubmit={updateAccessory} title="Editar Acessório" btnText="Salvar" btCancelAction={btCancelAction} accessoryData={accessory} />
        )
    )
}

export default EditAccessory